/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import { Print } from "@material-ui/icons";
import { useReactToPrint } from "react-to-print";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import Slide from "@mui/material/Slide";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import Axios from "axios";
import { thaiNumber } from "../components/functions/education";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function HistoryBook({ Data, Img }) {
  const [open, setOpen] = React.useState(false);
  const [idCardData, setIdCardData] = React.useState(null);
  const [studentImage, setStudentImage] = React.useState(null);
  const [imageLoading, setImageLoading] = React.useState(false);

  const CourseName = localStorage.getItem("CourseName");
  // รองรับหลายชื่อ field จาก API (email, mememail, user)
  const EmailPersonStudent =
    Data?.email ?? Data?.mememail ?? Data?.user ?? "";

  //console.log("data: ", Img)
  // for (let i = 0; i < Img.length; i++) {
  //   var Testhave = Img[i];
  // }
  // console.log("data2: ",Data.memimgpath)

  const handleClickOpen = () => {
    setOpen(true);
    setStudentImage(null);
    setImageLoading(true);
    const loadImages = async () => {
      try {
        const cardData = await getIDCardImage();
        await getStudentImage(cardData);
      } finally {
        setImageLoading(false);
      }
    };
    loadImages();
  };

  const handleClose = () => {
    setOpen(false);
    setIdCardData(null);
    setStudentImage(null);
    setImageLoading(false);
  };

  const marginTop = "10cm";
  const marginRight = "0.5cm";
  const marginBottom = "0cm";
  const marginLeft = "0.5cm";

  const getPageMargin = () => {
    return `
        @page {
            size: A4 portrait;
            margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important;
            height: initial !important;
            overflow: initial !important;
        }
    `;
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "emp-data",
    pageStyle: getPageMargin(),
    onAfterPrint: () => alert("Print success"),
  });

  const getIDCardImage = React.useCallback(async () => {
    const baseUrl = (process.env.REACT_APP_IDCARD && String(process.env.REACT_APP_IDCARD).trim()) || "";
    if (!baseUrl) {
      setIdCardData(null);
      return null;
    }
    let email = EmailPersonStudent != null && EmailPersonStudent !== "" ? String(EmailPersonStudent).trim() : null;
    if (!email) {
      setIdCardData(null);
      return null;
    }
    // ถ้าเป็นรูปแบบ xxx@rtaf.mi.th ให้ส่งเฉพาะส่วนก่อน @
    if (email.includes("@")) email = email.split("@")[0];
    const body = JSON.stringify({ username: email });
    const config = {
      method: "POST",
      maxBodyLength: Infinity,
      url: baseUrl,
      headers: {
        authtoken: `bearer ${process.env.REACT_APP_TOKEN || ""}`,
        "Content-Type": "application/json",
      },
      data: body,
    };
    try {
      const response = await Axios.request(config);
      const res = response?.data;
      // รูปแบบ response: { idc, officer_id, result, user }
      if (res?.result === "Process-Complete") {
        const data = {
          result: res.result,
          idc: res.idc,
          officer_id: res.officer_id,
          user: res.user,
          picture_base64: res.picture_base64 || null,
        };
        setIdCardData(data);
        return data;
      } else {
        setIdCardData(null);
        return null;
      }
    } catch (error) {
      console.error("Error fetching ID card image:", error);
      setIdCardData(null);
      return null;
    }
  }, [EmailPersonStudent]);

  const getStudentImage = async (cardData = null) => {
    const idCard = cardData ?? idCardData;
    if (Img && Img.length === 1) {
      const perCardId = idCard?.idc ?? Img?.[0];
        if (perCardId == null) {
          setStudentImage(null);
          setImageLoading(false);
          return;
        }
        const apiBase = String(process.env.REACT_APP_API || "").trim().replace(/\/$/, "");
        const engtestUrl = apiBase ? `${apiBase}/proxy/Engtest` : "";
        if (!engtestUrl) {
          setStudentImage(null);
          setImageLoading(false);
          return;
        }
        return Axios.post(
          engtestUrl,
          {
            idCardData: idCard,
            idc: idCard?.idc ?? perCardId,
            PER_CARDID: perCardId,
          }
        )
          .then((res) => {
            setStudentImage(res.data[0].PIC)
            // console.log("res: ", res.data[0])
          })
          .catch((err) => {
            setStudentImage(null);
            if(err.response?.data?.message) {
              console.log("err: ", err)
            } else {
              console.log("err: ", err.response?.data)
            }
          })
          .finally(() => setImageLoading(false));
    } else {
      setImageLoading(false);
    }
  };
        // const apiKey = process.env.REACT_APP_KEY || "";

  var thaiNum = thaiNumber(Data.StudentId);
  // const base64_img = `data:image/jpeg;base64,${getImage.picture_base64}`
  // console.log("getImage 1: ",getImage)
  // console.log("base64_img: ",Data.memimgpath)

  return (
    <div>
      <Print onClick={handleClickOpen} />
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              พิมพ์ประวัติบุคคล
            </Typography>
            <Button
              variant="contained"
              onClick={handlePrint}
              startIcon={<Print />}
            >
              Print
            </Button>
          </Toolbar>
        </AppBar>
        <List>
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "center" }}
            ref={componentRef}
          >
            <Box sx={{ border: "1px solid #000000", width: "540px" }}>
              <Box sx={{ display: "flex", margin: "10px" }}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography variant="subtitle1" gutterBottom>
                      หมายเลข: {thaiNum}
                    </Typography>
                    {/* {idCardData?.idc && (
                      <Typography variant="subtitle2" gutterBottom sx={{ fontSize: "0.85rem" }}>
                        เลขบัตร: {idCardData.idc}
                      </Typography>
                    )} */}
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minWidth: 150, minHeight: 180 }}>
                    {imageLoading ? (
                      <CircularProgress size={48} />
                    ) : (
                      <img
                        className="imgPerson"
                        alt="รูปบัตรประจำตัว"
                        src={
                          studentImage && String(studentImage).trim()
                            ? `data:image/jpeg;base64,${studentImage}`
                            : "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
                        }
                      />
                    )}
                  </Box>
                </Box>
                {/* <div className="ContainerPrint"> */}
                <Box>
                  <Box sx={{ display: "flex", marginLeft: "30px" }}>
                    <Box>
                      <Typography variant="subtitle1" gutterBottom>
                        ยศ-ชื่อ:{" "}
                        {Data.Rank + Data.PersFname + "  " + Data.PersLname}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", flexWrap: "nowrap", alignItems: "flex-start", marginLeft: "30px", gap: "20px" }}>
                    <Box sx={{ minWidth: 0, flex: "1 1 0%" }}>
                      <Typography variant="subtitle1" gutterBottom sx={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                        สังกัด: {Data.PersAffiliation}
                      </Typography>
                    </Box>
                    <Box sx={{ flexShrink: 0, marginLeft: "auto", paddingLeft: "20px" }}>
                      <Typography variant="subtitle1" gutterBottom sx={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                        เหล่า: {Data.PersCorps}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", marginLeft: "30px" }}>
                    <Box>
                      <Typography variant="subtitle1" gutterBottom>
                        หลักสูตร: {CourseName}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", marginLeft: "30px" }}>
                    <Box>
                      <Typography variant="subtitle1" gutterBottom>
                        ตำแหน่ง: {Data.PersCurrPosition}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", marginLeft: "30px" }}>
                    <Box>
                      <Typography variant="subtitle1" gutterBottom>
                        e-mail: {Data.email}@rtaf.mi.th
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                {/* </div> */}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  margin: "10px",
                }}
              ></Box>
            </Box>
          </Box>
        </List>
      </Dialog>
    </div>
  );
}

export default HistoryBook;
